//将base64转换为文件
const dataURLtoFile = (dataurl, filename) => {
  const arr = dataurl.split(',')
  const mime = arr[0].match(/:(.*?);/)[1]
  const bstr = atob(arr[1])
  let n = bstr.length
  const u8arr = new Uint8Array(n)
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n)
  }

  return new File([u8arr], filename, { type: mime })
}

const canvasDataURL = (path, option, callback) => {
  const img = new Image()
  img.src = path
  img.onload = function () {
    // 原图尺寸
    const orWidth = this.width
    const orHeight = this.height
    const scale = orWidth / orHeight
    // 计算尺寸
    let w = option.width
    let h = 0

    // 原图尺寸小于等于设置尺寸，取原图尺寸
    if (orWidth <= option.width) {
      w = orWidth
    }
    // 通过比例计算高度
    h = Math.ceil(w / scale)

    //生成canvas
    const canvas = document.createElement('canvas')
    const ctx = canvas.getContext('2d')

    // 创建属性节点
    const anw = document.createAttribute("width")
    anw.nodeValue = w
    const anh = document.createAttribute("height")
    anh.nodeValue = h
    canvas.setAttributeNode(anw)
    canvas.setAttributeNode(anh)
    ctx.drawImage(this, 0, 0, w, h)

    const base64 = canvas.toDataURL(`image/${option.format}`, option.quality)
    const file = dataURLtoFile(base64, `image_${Date.now()}.${option.format}`)
    callback && callback({ file, base64 })
  }
}

const photoCompress = (file, { quality = 0.7, width = 800, format = 'jpg', minSize = 50 }) => {
  return new Promise(resolve => {
    if (!file) {
      return resolve({
        success: false,
        message: 'file is undefined!',
        result: null
      })
    }

    if (file.size <= minSize * 1024) {
      return resolve({
        success: true,
        message: '图片处理成功',
        result: {
          file,
          base64: null
        }
      })
    }

    if (isNaN(quality) || (quality <= 0 || quality >= 1)) {
      quality = 0.7
    }
    if (isNaN(width) || (width <= 0 || width >= 1080)) {
      width = 800
    }

    const reader = new FileReader()
    reader.onload = function (e) {
      canvasDataURL(e.target.result, { quality, width, format }, function (data) {
        if (data) {
          return resolve({
            success: true,
            message: '图片处理成功',
            result: data
          })
        } else {
          return resolve({
            success: false,
            message: '图片处理失败',
            result: null
          })
        }
      })
    }
    reader.readAsDataURL(file)
  })
}

/*
file：图片文件
option：
  width：图片压缩宽度，当图片原先宽度小于预定值时取原先宽度，默认800，系统限制最大值1080
  format：图片格式，默认jpg
  quality：压缩质量，0～1之间，默认1，quality值越小，所绘制出的图像越模糊
  minSize：最小压缩尺寸阀值，默认50kb，只有当大于该值时才会被处理压缩，否则直接返回源文件
**/
export default photoCompress